export const COMBINE_ORDERS = 'COMBINE_ORDERS'
export const COMBINE_ORDERS_FAILED = 'COMBINE_ORDERS_FAILED'

export const combineOrders = (payload = {}) => ({
  type: COMBINE_ORDERS,
  payload,
})

export const combineOrdersFailed = (payload = {}) => ({
  type: COMBINE_ORDERS_FAILED,
  payload,
})
